module.exports = __webpack_public_path__ + "04_mustache_black.a5e44447.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer3/04_mustache_black.png
// module id = l50P
// module chunks = 0